import { ListingCate } from '@/page-commons/listingBySlug'

const get = (descriptions: ListingCate['descriptions'], language: Locale): ListingCate['descriptions'][number] => {
  const translatedDescription = descriptions.find((d) => d.language.toLowerCase() === language.toLowerCase())
  if (translatedDescription && translatedDescription.propertyDescription) {
    return translatedDescription
  }
  return descriptions[0]
}

const descriptionTranslations = {
  get,
}

export default descriptionTranslations
